import DeletionFailure from './DeletionFailure';

export default DeletionFailure;
